namespace HA.Core.HTML {
    export class HTML extends HAObject {

    }
}
